import { createFileRoute } from '@tanstack/react-router';
import AccessMatrix from '@/pages/AccessMatrix';

export const Route = createFileRoute('/access_matrix')({
  component: AccessMatrix,
});
